import { atom } from 'jotai';

export interface NavigationContext {
  featureIds: string[];
  currentIndex: number;
  cameraPosition: [number, number, number];
  layerId: string;
}

export const featureNavigationAtom = atom<NavigationContext | null>(null);
